import React, { useState } from "react";
import bg1 from "../img/bg1.jpg";
import bg2 from "../img/bg2.jpg";
import bg3 from "../img/bg3.jpg";
import Pantelogo from "./Pantelogo";

export default function Gallery({ width, height, images, time, description }) {
  const containerDimensions = {
    height: height ? height : "100vh",
    width: width ? width : "100%",
  };
  const backgroundImages = images || [bg1, bg2, bg3];
  const carouselLength = backgroundImages.length;
  const [currentCarouselIndex, setCarouselIndex] = useState(0);
  const [titles, setTitles] = useState([
    "Hvordan hindre flasker fra å havne i naturen?",

    "Hva skal jeg gjøre med flaska når jeg har drukket opp?",

    "Hjelp, det er ingen panteautomat i nærheten!",

    "Hjelp! Jeg vil ikke være en plast-forsøpler!]",
  ]);
  React.useEffect(() => {
    const interval = setInterval(() => {
      setCarouselIndex((currentCarouselIndex) => {
        const newIndex =
          currentCarouselIndex + 1 >= carouselLength
            ? 0
            : currentCarouselIndex + 1;
        return newIndex;
      });
    }, time || 8000);
    return () => clearInterval(interval);
  }, [currentCarouselIndex, time, carouselLength]);

  const carousel = backgroundImages.map((element, index) => {
    return (
      // <img
      <div
        key={index}
        className={
          currentCarouselIndex === index ? "bgimg active" : "bgimg inactive"
        }
        style={{ backgroundImage: "url(" + element + ")" }}
      />
    );
  });

  const title = titles.map((element, index) => {
    return (
      // <img
      <div
        key={index}
        className={
          currentCarouselIndex === index
            ? "headings active"
            : "headings inactive"
        }
      >
        <h1>{element}</h1>
        <p>{description}</p>
      </div>
    );
  });

  return (
    <>
      <div className="gallery">{carousel}</div>
      <div className="header">
        <Pantelogo />
        <div className="headerlogo"></div>
        <div className="headercontainer container">
          <div className="innrykk col-2"></div>
          <div className="headertxt col-10">{title}</div>
        </div>
      </div>
    </>
  );
}
